/** @format */

import { Col } from 'antd';
// import qs from 'qs';
import React, { useState, useEffect } from 'react';
import { Helmet } from 'react-helmet';
import { useLocation } from 'react-router-dom/cjs/react-router-dom.min';
// import { ENV_COUNTRY } from '../../components/Commons//Hooks/Variables/Enviroment';
import MetaDescription from '../../components/Commons/MetaDescription';
// import Elastic from '../../components/Elastic';
// import { HandleFacets } from '../../components/Elastic/functions/HandleFacets';
import SlidersInternal from '../../v2-components/SlidersInternal';
import { ENVIROMENT } from '../../v2-config/constants/enviroment.constant';
import useWindowScreen from '../../v2-custom-hooks/useWindowsScreen.hook';
import { IsMobile } from '../../_config/utils/is-mobile.util';
// import { Country } from './country';
// import NewsModal from '../home/components/NewsModal';
import PopUpModal from '../../v2-components/PopUp';
import Carousel from '../../components/Commons/Carousel';
import { Service } from './services';
import './style.scss';
import BannerPromotionsV2 from '../../v2-components/BannerPromotions';
import seo from '../../_config/global/seo.json';
import { isHomeRedesignEnabled } from '../../v2-config/constants/pharmacy-features.constant';
import HomeCategories from '../home/components/HomeCategories';
import BenefitsBar from '../home/components/BenefitsBar';

export default function Pharmacy(props) {
	const widthScreen = useWindowScreen();
	const params = useLocation();
	const location = useLocation();
	// const [isQuery] = useState(qs.parse(params.search.slice(1)));
	const [isPopUpModalShown, setIsPopUpModalShown] = useState(false);
	const [carousels, setCarousels] = useState([]);
	const isBottomCarousel = (item) => item?.slot === 'bottom' || (item?.tag || '').endsWith('home-bottom');
	const bottomCarousel = carousels.find(isBottomCarousel);
	const topCarousel = carousels.find((item) => !isBottomCarousel(item));

	const canonicalUrl = `${window.location.origin}${location.pathname}`;
	const homeH1 = (seo.homeH1 || `${seo.siteName || ''}${seo.tagline ? ` | ${seo.tagline}` : ''}`).trim();
	const isRoot = location.pathname === '/';
	const showHomeRedesign = isRoot && isHomeRedesignEnabled();

	useEffect(() => {
		window.scroll(0, 0);
	}, [params]);

	useEffect(() => {
		const modalShown = localStorage.getItem('isPopUpModalShown');
		if (!modalShown) {
			setIsPopUpModalShown(true);
			localStorage.setItem('isPopUpModalShown', 'true');
		}
	}, []);

	useEffect(() => {
		new Service()
			.getPharmacyCarousel()
			.then((response) => {
				const payload = response.data || {};
				const list = payload.carousels?.length
					? payload.carousels
					: [{ products: payload.products || [], editable_name: payload.editable_name }];
				setCarousels(list);
			})
			.catch((error) => {
				console.log('error', error);
			});
	}, []);

	// const handleFilters = () => {
	// 	const query = isQuery.q ? isQuery.q : '';
	// 	const filters = Country[ENV_COUNTRY].handleFilters(props.match.params);
	// 	const index = Country[ENV_COUNTRY].handleElasticPrecision(query);
	// 	const sort = Country[ENV_COUNTRY].handleSort();
	// 	const facets = HandleFacets();
	// 	const params = { filters, query, index, facets, sort };
	// 	return params;
	// };
	return (
		<>
			<Helmet>
				<link rel="canonical" href={canonicalUrl} />
			</Helmet>
			<MetaDescription title={`${ENVIROMENT.ROOT_NAME}`} name={'description'} content={`descripcion`} />
			{isRoot && homeH1 && <h1 className="ph-home-h1-sr-only">{homeH1}</h1>}
			<Col span={24}>
				{showHomeRedesign && <HomeCategories />}
				{!IsMobile(widthScreen) ? (
					<SlidersInternal template={'home'} location={'sliders-desktop'} />
				) : (
					<SlidersInternal template={'home'} location={'sliders-mobile'} />
				)}
				{showHomeRedesign && <BenefitsBar />}
				{topCarousel?.products?.length > 0 && (
					<>
						<h2 className="ph-home-title">{topCarousel.editable_name}</h2>
						<Carousel navId="home-top" carouselItems={[5, 3, 2, 2, 1]} type="product" list={topCarousel.products} featured={true} />
					</>
				)}
			</Col>
			<BannerPromotionsV2 template={'home'} location={'horizontal-box'} numColWeb={12} numColMobile={24} />
			<BannerPromotionsV2 template={'home'} location={'vertical-box'} numColWeb={6} numColMobile={12} />
			{bottomCarousel?.products?.length > 0 && (
				<Col span={24}>
					<h2 className="ph-home-title">{bottomCarousel.editable_name}</h2>
					<Carousel navId="home-bottom" carouselItems={[5, 3, 2, 2, 1]} type="product" list={bottomCarousel.products} featured={true} />
				</Col>
			)}
			{/* <Elastic params={handleFilters()} placeholcerSearchBox={'Buscar en esta farmacia'} template={'home'} location={'sidebar'} /> */}
			{isPopUpModalShown && <PopUpModal template={'home'} location={'popup'} />}
			{/* <NewsModal newsData /> Viejo popup*/}
		</>
	);
}
